import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface WasteCode {
    _id: string;
    designation: string;
    description: string;
    crudStatus: number;
    usageCount?: {
        total: number;
        dailyTrucksPlanned: number;
        dailyTrucksRides: number;
    };
    updatedAt?: string;
    createdAt?: string;
}

export interface WasteCodesResponse {
    message: string;
    data: WasteCode[];
}

export interface GetWasteCodesQueries {
    active?: boolean;
    withUsage?: boolean;
    dangerous?: boolean;
}

export const getAllWasteCodes = async (queries?: GetWasteCodesQueries): Promise<WasteCodesResponse> => {
    try {
        const response: AxiosResponse<WasteCodesResponse> = await apiClient.get('/waste-codes', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface WasteCodeResponse {
    message: string;
    data: WasteCode;
}

export const getWasteCodeById = async (wasteCodeId: string): Promise<WasteCodeResponse> => {
    try {
        const response: AxiosResponse<WasteCodeResponse> = await apiClient.get('/waste-codes/' + wasteCodeId);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateWasteCodeBody {
    designation?: string;
    description?: string;
    crudStatus?: number;
}

export const updateWasteCode = async (wasteCodeId: string, data: UpdateWasteCodeBody): Promise<WasteCodeResponse> => {
    try {
        const response: AxiosResponse<WasteCodeResponse> = await apiClient.patch('/waste-codes/' + wasteCodeId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateWasteCodeBody {
    designation: string;
    description: string;
    crudStatus?: number;
}

export const createWasteCode = async (data: CreateWasteCodeBody): Promise<WasteCodeResponse> => {
    try {
        const response: AxiosResponse<WasteCodeResponse> = await apiClient.post('/waste-codes', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const softDeleteWasteCode = async (wasteCodeId: string): Promise<WasteCodeResponse> => {
    try {
        const response: AxiosResponse<WasteCodeResponse> = await apiClient.patch('/waste-codes/' + wasteCodeId + '/soft-delete');
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
